var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SubAdvisorConsentDisagree',{attrs:{"investorInfo":_vm.investorInfo,"getCalendlyLink":_vm.getCalendlyLink},on:{"exit":_vm.onExit}})
}
var staticRenderFns = []

export { render, staticRenderFns }